import { Card, CardBody, Col, Row } from 'reactstrap';

interface Props {
  cover: string | undefined;
  address: string | undefined;
  code: number | undefined;
  price: string | undefined;
  sale_price?: string | undefined;
  name?: string;
}

// "$0.00" parece un precio real; se trata como "sin precio".
const isZeroPrice = (value: string) =>
  Number(value.replace(/[^0-9.-]/g, '')) === 0;

const PropertyDetailCard = (props: Props) => {
  const {
    cover = '',
    address = '',
    code = 0,
    price = '',
    sale_price = '',
    name = '',
  } = props;
  return (
    <Card>
      <CardBody>
        <Row className="align-items-center">
          <Col className="col-auto">
            <img
              className="rounded"
              alt="..."
              width={175}
              height={100}
              src={
                cover
                  ? cover
                  : 'https://storage.googleapis.com/assets-us-east4-propilatam-dev/properties/default/default_1.jpg'
              }
            />
          </Col>
          <div className="col ml--2">
            <h4 className="mb-0">
              #{code} {name}
            </h4>
            <p className="text-sm mb-2" style={{ color: '#525f7f' }}>
              {address}
            </p>
            <div className="d-flex flex-wrap">
              {price && !isZeroPrice(price) && (
                <span className="badge badge-secondary text-dark font-weight-bold mr-2 mb-1 py-2 px-3"
                  style={{ textTransform: 'none' }}>
                  Renta {price}/mes
                </span>
              )}
              {sale_price && !isZeroPrice(sale_price) ? (
                <span
                  className="badge badge-secondary text-dark font-weight-bold mb-1 py-2 px-3"
                  style={{ textTransform: 'none' }}
                >
                  Venta {sale_price}
                </span>
              ) : (
                // solo las pantallas que reciben precio de venta lo muestran
                props.sale_price !== undefined && (
                  <small style={{ color: '#525f7f' }} className="py-2">
                    No está en venta
                  </small>
                )
              )}
            </div>
          </div>
        </Row>
      </CardBody>
    </Card>
  );
};

export default PropertyDetailCard;
